import { p as proxyCustomElement, H, h, c as Host } from './p-DUAwwEEc.js';
import { r as removeSSRSlot } from './p-CmCPGxtg.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.4.1
 */

let sidenavSectionId = 0;
const SidenavSection = /*@__PURE__*/ proxyCustomElement(class SidenavSection extends H {
    constructor() {
        super();
        this.__registerHost();
        this.componentId = `sidenav-section-header-${sidenavSectionId++}`;
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '902c0cbe026e1e3e2ed3f17d720aa6df2bebc483', class: "tds-sidenav-section" }, this.label && (h("h2", { key: 'cc47b2ba8b5ebf588a9ab967489c5a67c5f2d6cd', id: `${this.componentId}`, class: "tds-sidenav-section-header" }, this.label)), h("ul", { key: '9969a44f9004e5a599da41a4a429a712e9a2df96', class: "tds-sidenav-section-list", "aria-labelledby": this.label ? `${this.componentId}` : undefined }, h("slot", { key: '791b7f0e571b8f4f99342b1e711c6b04d09ee341' }))));
    }
    get el() { return this; }
}, [6, "tds-sidenav-section", {
        "label": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-section"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-section":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SidenavSection);
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav-section.js.map
